<app-relatorio-container
    tituloRelatorio="Declaração de Dados da Empresa"
    descricaoRelatorio="Ficha de declaração de dados cadastrais da empresa."
    categoriaRelatorio="Cadastro"
    [filtrosTemplate]="filtrosTemplate"
    [pdfBlob]="(job$ | async)?.pdfBlob"
    [pdfFileName]="(job$ | async)?.fileName ?? 'declaracao-dados-empresa-pj.pdf'"
    [statusPreview]="(job$ | async)?.status ?? null"
    [progressoPreview]="(job$ | async)?.progress ?? 0"
>
    <ng-template #filtrosTemplate>
        <div class="flex flex-col gap-6">
            <p class="text-sm text-color-secondary m-0">A ficha é emitida com os dados cadastrais do prestador selecionado. Nenhum filtro adicional é necessário.</p>

            <div class="field pt-5 flex justify-end gap-2">
                <p-button label="Limpar" icon="pi pi-eraser" [variant]="'text'" (click)="limparFormulario()"></p-button>
                <p-button label="Gerar Declaração" icon="pi pi-file-pdf" [appCan]="roleGerar" (click)="gerarRelatorio()" [loading]="isPending" [disabled]="isPending"></p-button>
            </div>
        </div>
    </ng-template>
</app-relatorio-container>
